import React, { useState, useMemo } from 'react';
import classNames from 'classnames';
import { Button, Display } from '../Button/Button';

export interface ITabConfig {
	name: string;
	component: React.ReactNode;
	key: string;
	className?: string;
	disabled?: boolean;
}

export interface ITabsProps {
	tabs: Array<ITabConfig>;
	className?: string;
	// Key of the current tab that matches ITabConfig
	currentTab?: string;
	onTabClicked?: (tabKey: string, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface ITabHeaderProps {
	isSelected: boolean;
	disabled?: boolean;
	tabKey: string;
	onClick: (tabKey: string, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	children: React.ReactNode;
}

const TabHeader: React.FC<ITabHeaderProps> = ({
	isSelected,
	disabled,
	tabKey,
	onClick,
	children
}) => {

	const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		if (!isSelected) {
			onClick(tabKey, event);
		}
	};

	return (
		<Button disabled={disabled} display={Display.Text} onClick={handleClick}>
			{children}
		</Button>
	);
};

// TODO - EPIC REVIEW CUSTOMER APPLICATION
// - Needs to be styled like the other tabs.
// - Currently have 2 different styling for tabs (refer to esign tab and customer profile tab). We should consolidate these.
const Tabs: React.FC<ITabsProps> = ({
	tabs,
	className,
	currentTab,
	onTabClicked,
}) => {

	const handleTabClick = (tabKey: string, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		if (onTabClicked) onTabClicked(tabKey, event);
	};

	const selectedTabConfig = useMemo(() => {
		return tabs.find(x => x.key === currentTab)
	}, [tabs, currentTab]);

	// Empty view
	if (tabs.length == 0) return <></>;

	return (
		<>
			<nav className={classNames('tabs', className)}>
				<ul>
					{tabs.map((tab, idx) => {
						const selected = currentTab === tab.key;
						const clzName = classNames('tab-header', { selected: selected });

						return (
							<li key={tab.key} className={clzName}>
								<TabHeader
									isSelected={selected}
									disabled={tab.disabled}
									tabKey={tab.key}
									onClick={handleTabClick}
								>
									{tab.name}
								</TabHeader>
							</li>
						)
					})}
				</ul>
			</nav>

			{selectedTabConfig && (
				<div className={classNames(selectedTabConfig.className)}>
					{selectedTabConfig.component}
				</div>
			)}
		</>
	);
};

export default Tabs;